const fields = [
  {
    dataIndex: 'index',
    key: 'index',
    title: '序号',
    width: 80,
    scopedSlots: {
      customRender: 'subscript'
    }
  },
  {
    dataIndex: 'enpName',
    key: 'enpName',
    title: '企业名称'
  },
  {
    dataIndex: 'patentCount',
    key: 'patentCount',
    title: '专利数',
    width: 100
  },
  {
    dataIndex: 'endUpdateTime',
    key: 'endUpdateTime',
    title: '最后更新日期'
  },
  {
    dataIndex: 'sortIndex',
    key: 'sortIndex',
    title: '排序号',
    width: 80
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 100,
    scopedSlots: {
      customRender: 'action'
    }
  }
]

const formRow = [
  {
    span: 12,
    label: '企业名称',
    component: 'AInput',
    placeholder: '请输入企业名称',
    prop: 'enpName',
    allowClear: true
  }
]

const slotOpt = [
  {
    slot: 'action',
    component: 'Action',
    list: [{ name: '删除', cb: 'delete' }]
  }
]

module.exports = {
  fields,
  formRow,
  slotOpt
}
